<template>
    <ValidationObserver ref="form">
        <h3 class="profile__ttl">Address for mailings:</h3>
        <div class="row mb-4">

            <ValidationProvider
                class="col-md-6"
                name="Line 1"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Address Line1*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="addressInfo.line1"
                    >
                    <FormError :error="errors[0]" name="Line 1"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Line 2"
                v-slot="{ errors }"
                rules="min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Address Line2*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="addressInfo.line2"
                    >
                    <FormError :error="errors[0]"  name="Line 2"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="City/Town"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">City/Town*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="addressInfo.city"
                    >
                    <FormError :error="errors[0]" name="City/Town"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="State/Province"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">State/Province*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="addressInfo.state"
                    >
                    <FormError :error="errors[0]" name="State/Province"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Country"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Country*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="addressInfo.country"
                    >
                    <FormError :error="errors[0]"  name="Country"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-3"
                name="Zip Code"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Zip Code*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="addressInfo.zip"
                    >
                    <FormError :error="errors[0]" name="Zip Code"/>
                </div>
            </ValidationProvider>
        </div>
    </ValidationObserver>

</template>

<script>
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import FormError from "../Common/FormError.vue";

export default {
    name: 'ArtistAddressInformation',
    components: {FormError},
    watch: {
        addressInfo: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    },

    mounted() {
        this.dispatchState(this.addressInfo);
    },

    computed: {
        ...mapState(useArtistStore, {
            addressInfo: 'addressInfo',
        }),
    }
}

</script>

<style scoped>

</style>
